import techSpecs from "@/libs/tactsuit/tech-spec.json";

export interface TechSpec {
  name: string;
  src: string;
  hapticPoints: {
    number: number;
    description: string;
  };
  connectivity: {
    type: string;
    description: string;
    note: string;
  };
  playtime: {
    hours: number;
    note: string;
  };
  sizeDetails: {
    type: string;
    size: string;
    closedLength: string;
    openedLength: string;
    width: string;
    weight: string;
    note: string;
  };
  chargingAndBattery: {
    chargingTime: string;
    chargeDetails: string;
    batterySpec: string;
  };
  compatibility: Array<{
    platform: string;
    value: string;
  }>;
  slug?: string;
}

export const TECH_SPEC_SLUG_LIST = Object.keys(techSpecs);

export const getTechSpec = (slug: string): TechSpec => {
  return {
    ...techSpecs[slug],
    slug,
  };
};

export const getCompatibility = (
  slug: string,
): {
  platform: string;
  value: string;
}[] => {
  // Dual(Pro · Air · Air Camo) — 시안 `TechSpecsTable` 31584:38677 값(2026-10-29, 사용자 결정 「시안에 맞추자」).
  // 시안 안에서도 갈리는 표기(「Support」/「support」 · 「Haptics」/「Haptic」 · 「Console(PS VR2)」 띄어쓰기)는
  // 번역 키가 있는 쪽(「Native support & Wired Audio-to-Haptic」)과 같은 표기로 맞췄다.
  if (techSpecs[slug].connectivity.type === "Dual") {
    return [
      {
        platform: "Meta Quest 3, 3S, Pro and 2",
        value: "Native support & Wired Audio-to-Haptic",
      },
      {
        platform: "PC VR (Steam VR)",
        value: "Native support, Mod support & Wireless Audio-to-Haptic",
      },
      {
        platform: "Console (PS VR2)",
        value: "Native support & Wired Audio-to-Haptic",
      },
      {
        platform: "PC Game",
        value: "Native support, Official Mod & Wireless Audio-to-Haptic",
      },
    ];
  }

  return [
    {
      platform: "Meta Quest 3, 3S and 2",
      value: "Native support",
    },
    {
      platform: "PC VR(Steam VR)",
      value: "Native / Mod support",
    },
    {
      platform: "Console(PS VR)",
      value: "Native support",
    },
  ];
};
